module.exports = __webpack_public_path__ + "00ab9b83772020de4a3f736f3b2742ca.png";